if ( typeof AnnouncementBar !== 'function' ) {

  class AnnouncementBar extends HTMLElement {

    constructor() {

      super();

      this.slider = this.querySelector('[data-js-slider]');
      this.content = this.querySelectorAll('.announcement');

      this.index = 0;
      this.length = this.content.length;
      this.autoSlideInterval = null;
      this.slideInterval = 10000; // 10 seconds
      this.currentColorIndex = 0; // Track current color index

      // Pause auto-slide on hover
      this.addEventListener('mouseenter', () => {
        this.stopAutoSlide();
      });

      // Resume auto-slide when mouse leaves
      this.addEventListener('mouseleave', () => {
        if (this.length > 1) {
          this.startAutoSlide();
        }
      });

      // Set initial background color
      this.rotateBackgroundColor();
      
      // Start auto-sliding if there are multiple announcements
      if (this.length > 1) {
        this.startAutoSlide();
      }
      
    }

    changeSlide(direction) {

      if ( direction == 'next' ) {
        this.index++;
      } else if ( direction == 'prev' ) {
        this.index--;
      }

      this.slider.scrollTo({
        top: 0,
        left: this.content[this.index].offsetLeft,
        behavior: 'smooth'
      });

      // Rotate background color on each slide change
      this.rotateBackgroundColor();

    }

    startAutoSlide() {
      this.autoSlideInterval = setInterval(() => {
        if (this.index < this.length - 1) {
          this.changeSlide('next');
        } else {
          // Reset to first slide
          this.index = -1; // Will be incremented to 0 in changeSlide
          this.changeSlide('next');
        }
      }, this.slideInterval);
    }

    stopAutoSlide() {
      if (this.autoSlideInterval) {
        clearInterval(this.autoSlideInterval);
        this.autoSlideInterval = null;
      }
    }

    rotateBackgroundColor() {
      // Alternate between #000000 and #394A2F
      const colors = ['#000000', '#394A2F'];
      const textColors = ['#FFFFFF', '#FFFFFF']; // White text for both backgrounds
      
      // Switch to the next color index
      this.currentColorIndex = this.currentColorIndex === 0 ? 1 : 0;
      const nextColor = colors[this.currentColorIndex];
      const nextTextColor = textColors[this.currentColorIndex];
      
      // Apply the background color with smooth transition
      this.style.setProperty('--announcement-bg-color', nextColor);
      this.style.background = nextColor;
      
      // Update text color for better contrast
      const announcements = this.querySelectorAll('.announcement');
      announcements.forEach(announcement => {
        announcement.style.color = nextTextColor;
      });
      
      console.log('Background color changed to:', nextColor); // Debug log
    }

    disconnectedCallback() {
      // Clean up interval when component is removed
      this.stopAutoSlide();
    }

  }

  if ( typeof customElements.get('announcement-bar') == 'undefined' ) {
    customElements.define('announcement-bar', AnnouncementBar);
	}

}